import React from 'react';
import {
    getAssignedBankTransactions,
    getAssignedPaymentProviderTransactions,
} from '../../../api';

const useAssignedTransactionsData = (hasAccounting) => {
    const [bankTransactions, setBankTransactions] = React.useState([]);
    const [paymentTransactions, setPaymentTransactions] = React.useState([]);
    const [bankLoading, setBankLoading] = React.useState(true);
    const [paymentLoading, setPaymentLoading] = React.useState(true);
    const [bankError, setBankError] = React.useState('');
    const [paymentError, setPaymentError] = React.useState('');

    const refresh = React.useCallback(async () => {
        if (!hasAccounting) {
            setBankTransactions([]);
            setPaymentTransactions([]);
            setBankLoading(false);
            setPaymentLoading(false);
            return;
        }
        setBankLoading(true);
        setPaymentLoading(true);
        setBankError('');
        setPaymentError('');
        try {
            const res = await getAssignedBankTransactions();
            setBankTransactions(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            setBankError('Bankvorgänge konnten nicht geladen werden.');
        } finally {
            setBankLoading(false);
        }

        try {
            const res = await getAssignedPaymentProviderTransactions();
            setPaymentTransactions(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            setPaymentError('Zahlungsanbieter-Vorgänge konnten nicht geladen werden.');
        } finally {
            setPaymentLoading(false);
        }
    }, [hasAccounting]);

    React.useEffect(() => {
        refresh();
    }, [refresh]);

    return {
        bankTransactions,
        bankLoading,
        bankError,
        paymentTransactions,
        paymentLoading,
        paymentError,
        refresh,
    };
};

export default useAssignedTransactionsData;
